
/**
 * 全局配置，可用于所有模块中
 */
interface Config {
    sessionId: string;
    [key: string]: any;
};

const GlobalConfig:Config = {
    sessionId: '',
    // 小程序专用
    appDevicePackageReady: false, // 公参app_package device_package是否设置完成，在getNetwork 成功后会被设为true
    identityPackageReady: false, // identity数据是否设置完成，调用setPublicParam后 设置完成。
};

export const updateConfig = (key: string, value: any) => {
    GlobalConfig[key] = value;
};

export const updateConfigs = (configs: {[key: string]: any}) => {
    Object.assign(GlobalConfig, configs);
}

export default GlobalConfig;